import {NavigationItem} from "../../main/model/navigationItem";
import * as angular from "angular";
import {IModule} from "angular";
import {UserGranredAuthorityName} from "../const/AllPermitions";

export class ModuleConfiguration {

    public name: string;
    public dependentModulesNames: string[];

    constructor(name: string,
                dependentModulesNames: string[]) {
        this.name = name;
        this.dependentModulesNames = dependentModulesNames;
    }

    public createNewModule = (): IModule => angular.module(this.name, this.getDependentModulesNames());

    public getDependentModulesNames(): string[] {
        return this.dependentModulesNames.filter(el => el != this.name);
    }

    public getAllModulesNames(): string[] {
        return [this.name, ...this.dependentModulesNames];
    }

    public matches = (q) => this.name === q;

}

export class RouteModuleConfiguration extends ModuleConfiguration {

    public routerConfig: [string, ng.route.IRoute][];
    public navigationItems: NavigationItem[];
    public controllerModulesNames: string[];
    public title: string;

    constructor(name: string,
                dependentModulesNames: string[],
                routerConfig: [string, ng.route.IRoute][],
                navigationItems: NavigationItem[],
                controllerModulesNames: string[],
                title: string) {
        super(name, dependentModulesNames);
        this.routerConfig = routerConfig;
        navigationItems.forEach(item => item.module = this);
        this.navigationItems = navigationItems;
        this.controllerModulesNames = controllerModulesNames;
        this.title = title;
    }
}


export class RestrictedRouteModuleConfiguration extends RouteModuleConfiguration {
    public requiredAccessLevels: UserGranredAuthorityName[];


    constructor(name: string,
                dependentModulesNames: string[],
                routerConfig: [string, ng.route.IRoute][],
                navigationItems: NavigationItem[],
                controllerModulesNames: string[],
                requiredAccessLevels: UserGranredAuthorityName[],
                title?: string) {
        super(name,
            dependentModulesNames,
            routerConfig,
            navigationItems,
            controllerModulesNames,
            title);
        this.requiredAccessLevels = requiredAccessLevels;
    }

    static instance(name: string,
                    dependencyProvider: () => string[],
                    routerConfig: [string, ng.route.IRoute][],
                    navigationItems: NavigationItem[],
                    controllerModulesNames: string[],
                    requiredAccessLevels: UserGranredAuthorityName[],
                    title?: string) {
        return new RestrictedRouteModuleConfiguration(
            name,
            dependencyProvider(),
            routerConfig,
            navigationItems,
            controllerModulesNames,
            requiredAccessLevels,
            title
        );
    }
}


